import React from "react";
import { Card, Row, Col, Badge, Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FaEdit, FaCopy, FaChartLine, FaTrash, FaCalendarAlt } from "react-icons/fa";
import { Link } from "react-router-dom";
import dayjs from "dayjs";

const SurveyList = ({ surveys, startEditing, confirmActionHandler, loading }) => (
  <Row className="g-4">
    {surveys.map((survey) => (
      <Col md={6} lg={4} key={survey.id || survey.surveyid}>
        <Card className="shadow-sm h-100 border-0 survey-card">
          <Card.Body className="p-4 d-flex flex-column">
            {/* Top Row: Responses (left) + Title/Meta (right) */}
            <div className="d-flex mb-3">
              {/* Responses block (clickable via Link) */}
              <Link
                to={`/feedback/feedback-responses?survey=${survey.surveyid}`}
                className="d-flex flex-column align-items-center justify-content-center p-3 rounded flex-shrink-0 text-decoration-none"
                style={{ width: "40%", backgroundColor: "#f0f4ff" }}
              >
                <div
                  className="fw-bold text-primary"
                  style={{ fontSize: "2.5rem", lineHeight: "1" }}
                >
                  {survey.responses}
                </div>
                <div className="fw-semibold text-dark">Responses</div>
              </Link>

              {/* Right side: title + meta */}
              <div className="flex-grow-1 ms-3 d-flex flex-column">
                <div className="d-flex justify-content-between align-items-start mb-2">
                  <h6 className="mb-0 fw-semibold text-dark">{survey.title}</h6>
                  <Badge
                    bg={
                      survey.status === "Active"
                        ? "success"
                        : survey.status === "Draft"
                        ? "secondary"
                        : "warning"
                    }
                    pill
                    className="px-3 py-2 text-capitalize"
                    style={{ fontSize: "0.7rem" }}
                  >
                    {survey.status}
                  </Badge>
                </div>

                <div className="text-muted small d-flex align-items-center mb-1">
                  <FaCalendarAlt className="me-2" />
                  Created: {dayjs(survey.createdAt).format("DD MMM YYYY")}
                </div>
                <div className="text-muted small d-flex align-items-center">
                  <FaCalendarAlt className="me-2" />
                  Last Response:{" "}
                  {survey.lastResponse
                    ? dayjs(survey.lastResponse).format("DD MMM YYYY")
                    : dayjs().format("DD MMM YYYY")}
                </div>
              </div>
            </div>
          </Card.Body>

          {/* Footer Actions */}
          <Card.Footer className="bg-white border-0 d-flex justify-content-between px-4 py-3">
            <OverlayTrigger placement="top" overlay={<Tooltip>Edit Survey</Tooltip>}>
              <Button
                size="sm"
                variant="light"
                onClick={() => startEditing(survey)}
                className="p-2"
              >
                <FaEdit className="text-primary" />
              </Button>
            </OverlayTrigger>

            <OverlayTrigger placement="top" overlay={<Tooltip>Duplicate</Tooltip>}>
              <Button
                size="sm"
                variant="light"
                onClick={() => confirmActionHandler("duplicate", survey)}
                className="p-2"
              >
                <FaCopy className="text-info" />
              </Button>
            </OverlayTrigger>

            <OverlayTrigger placement="top" overlay={<Tooltip>Analytics</Tooltip>}>
              <Link to="/feedback" className="btn btn-light btn-sm p-2">
                <FaChartLine className="text-success" />
              </Link>
            </OverlayTrigger>

            <OverlayTrigger placement="top" overlay={<Tooltip>Delete</Tooltip>}>
              <Button
                size="sm"
                variant="light"
                onClick={() => confirmActionHandler("delete", survey)}
                className="p-2"
              >
                <FaTrash className="text-danger" />
              </Button>
            </OverlayTrigger>
          </Card.Footer>
        </Card>
      </Col>
    ))}
  </Row>
);

export default SurveyList;
